import React, { useState, useEffect } from 'react'
import { T, SectionLabel, Spinner, Empty, SearchBar, searchMatch } from '../ui'
import { getNFLTrending } from '../api'
import { teamNick } from '../plain'

function Row({ p, onPlayer }){
  const up = p.trend === 'up'
  const col = up ? T.green : T.red
  return (
    <button onClick={()=>onPlayer && onPlayer({ full_name:p.name, pos:p.pos, team:p.team, opp:p.opp,
        note:`${up?'heating up':'cooling'} · ${p.recent} vs ${p.season} avg`, status:'active' })}
      style={{ display:'flex', width:'100%', textAlign:'left', cursor:'pointer', alignItems:'center',
        justifyContent:'space-between', background:T.card, border:`1px solid ${T.border}`, borderRadius:10,
        padding:'11px 13px', marginBottom:7, color:T.text }}>
      <div>
        <div style={{ fontWeight:800, fontSize:14 }}>{p.name} <span style={{ color:T.muted, fontSize:11 }}>{p.pos} · {teamNick(p.team)} vs {teamNick(p.opp)}</span></div>
        <div style={{ fontSize:11, color:T.muted, marginTop:2, fontFamily:T.mono }}>{p.recent} recent · {p.season} season avg</div>
      </div>
      <div style={{ fontFamily:T.mono, fontWeight:800, color:col, fontSize:15 }}>{up?'▲':'▼'}{Math.abs(p.delta_pct)}%</div>
    </button>
  )
}

export default function TrendsTab({ season, week, onPlayer }){
  const [d, setD] = useState(null)
  const [sample, setSample] = useState(false)
  const [q, setQ] = useState('')
  useEffect(()=>{ let a=true; getNFLTrending(season, week).then(r=>{ if(a){ setD(r); setSample(!!r._sample) } }); return ()=>{a=false} },[season,week])
  if(!d) return <Spinner/>
  const f = searchMatch(q, p => [p.name, p.team, p.opp, p.pos])
  const risers = (d.risers||[]).filter(f)
  const fallers = (d.fallers||[]).filter(f)
  return (
    <div style={{ padding:'6px 16px 80px' }}>
      {sample && <div style={{ fontSize:10, color:T.amber, marginTop:8 }}>● Live data unavailable right now</div>}
      {(d.risers?.length || d.fallers?.length) ? <SearchBar value={q} onChange={setQ} /> : null}
      <SectionLabel>🔥 Heating up · last 2 games</SectionLabel>
      {risers.length ? risers.map((p,i)=><Row key={i} p={p} onPlayer={onPlayer}/>) : <Empty message={q.trim()?`No risers match "${q}"`:"No risers yet"}/>}
      <SectionLabel>❄️ Cooling down</SectionLabel>
      {fallers.length ? fallers.map((p,i)=><Row key={i} p={p} onPlayer={onPlayer}/>) : <Empty message={q.trim()?`No fallers match "${q}"`:"No fallers yet"}/>}
    </div>
  )
}
